import { DefaultComponentProps } from '../../../types';

import styles from './BigWithSmallElementRow.module.css';

const BigWithSmallElementRow = ({ children }: DefaultComponentProps) => (
  <div className={styles.wrapper}>{children}</div>
);

export default BigWithSmallElementRow;
